export default __webpack_public_path__ + "static/media/granville20.9e5233f4.jpg";